import { useRouter } from 'next/router'

import { useGetCurrentUserCache } from '~user-profile/queries/useGetUserById'
import { WorkspacesTab as View } from 'ui-components'
import { useIsMyProfile } from '~user-profile/hooks/useIsMyProfile'

const Workspaces = () => {
  const router = useRouter()

  const isMyProfile = useIsMyProfile()
  const { data: user } = useGetCurrentUserCache()

  const handleCreateWorkspaceClick = () => {
    router.push('/workspace/create')
  }

  return (
    <View
      memberships={user?.membershipCollection?.items || []}
      canCreateWorkspace={isMyProfile}
      onCreateWorkspaceClick={handleCreateWorkspaceClick}
    />
  )
}

export { Workspaces }
